import { post, get, del } from 'services/http';

const getThemes = () => get('/themes');
const saveThemes = body => post('/themes', body);
const deleteThemes = () => del('/themes');

export default { saveThemes, getThemes, deleteThemes };
